/**
 * Centred "you don't own this yet" panel with a purchase call to action.
 *
 * The Commercial License and DFY Vault views each had their own copy of this
 * layout with slightly different padding (24px vs 28px vertical); the difference
 * is preserved via `padding` rather than flattened.
 *
 * This is presentation only. It is NOT an access control: a locked route renders
 * this in place of its content, but the real gate belongs on the server. Phase 4
 * wires the entitlement checks properly.
 */
import type { ReactNode } from 'react';
import { c } from '../../styles/theme';

export interface UpgradePromptProps {
  /** Large muted icon above the title. */
  icon: ReactNode;
  title: string;
  description: string;
  /** The purchase button. */
  action: ReactNode;
  /** Vertical padding in px. 24 on the License view, 28 on the Vault. */
  paddingY?: number;
}

export default function UpgradePrompt({
  icon,
  title,
  description,
  action,
  paddingY = 24,
}: UpgradePromptProps) {
  return (
    <div
      style={{
        background: c.surface1,
        border: `1px solid ${c.border}`,
        borderRadius: 12,
        padding: `${paddingY}px 20px`,
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: 10 }}>{icon}</div>
      <p style={{ fontWeight: 500, fontSize: 15, margin: '0 0 4px' }}>{title}</p>
      <p style={{ fontSize: 12, color: c.text2, margin: '0 0 16px' }}>{description}</p>
      {action}
    </div>
  );
}
